<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="项目单位：" prop="pid">
                <el-input :value="pnames[0]" disabled></el-input>
            </el-form-item>
            <el-form-item label="单位工程：" prop="pid" v-if="grade>=3">
                <el-input :value="pnames[1]" disabled></el-input>
            </el-form-item>
            <el-form-item label="分部工程：" prop="pid" v-if="grade>=4">
                <el-input :value="pnames[2]" disabled></el-input>
            </el-form-item>
            <el-form-item label="单位工程：" prop="name" v-if="grade==2">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item label="分部工程：" prop="name" v-if="grade==3">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item label="单元工程：" prop="name" v-if="grade==4">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item label="编号：" prop="code">
                <el-input v-model="model.code"></el-input>
            </el-form-item>
            <el-form-item label="简称：" prop="alias">
                <el-input v-model="model.alias"></el-input>
            </el-form-item>
            <el-form-item label="施工单位名称：" prop="construction_company" v-if="grade==2">
                <el-input v-model="model.construction_company"></el-input>
            </el-form-item>
            <el-form-item label="施工单位简称：" prop="construction_company_ab" v-if="grade==2">
                <el-input v-model="model.construction_company_ab"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" :rows="4" v-model="model.remark"></el-input>
            </el-form-item>
            <el-form-item label="顺序：" prop="order_index">
                <el-input v-model.number="model.order_index"></el-input>
            </el-form-item>
            <el-form-item label="场景类型：" prop="scene_type" v-if="grade==3">
                <el-select clearable v-model="model.scene_type" placeholder="请选择">
                    <el-option v-for="item in enuObj('scene_type')" :key="'scene_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="灌浆类型：" prop="grout_type" v-if="grade==4">
                <el-select clearable v-model="model.grout_type" placeholder="请选择">
                    <el-option v-for="item in enuObj('grout_type')" :key="'grout_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { getProjectDivisionParentNames } from '@/api/org'

export default {
    name: 'projectDivisionEdit',
    mixins: [editutil],
    props: {
        pid: {
            type: Number,
            default() {
                return 0;
            }
        },
        grade: {
            type: Number,
            default() {
                return 2;
            }
        }
    },
    data() {
        return {
            model: {
                code: '',
                name: '',
                alias: '',
                construction_company: '',
                construction_company_ab: '',
                remark: '',
                order_index: '',
                grout_type: '1',
                scene_type: '',
                grade: '',
                pid: '',
                pname: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/projectdivision/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['grout_type', 'scene_type'],
            rules: {
                code: [
                    {required: true, message: '编号不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                name: [
                    {required: true, message: '名称不能为空', trigger: 'blur'}
                ],
                alias: [
                    {required: true, message: '简称不能为空', trigger: 'blur'}
                ],
                order_index: [
                    {required: true, message: '顺序不能为空', trigger: 'blur'},
                    {type: 'number', message: '顺序必须是数字值', trigger: 'blur'}
                ],
                grout_type: [
                    {required: true, message: '灌浆类型不能为空', trigger: 'blur'},
                ]
            },
            pnames: [],
            checkObj:{
                url:'/api/admin/projectdivision/check',
                data:{}
            },
            exits_p_name:'code',
            exits_p_title:'编号',
        };
    },
    methods: {
        loadOtherData() {
            getProjectDivisionParentNames(this.pid).then(res=>{
                if(res.code ==1){
                    this.pnames = res.data
                }
            })
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/projectdivision/save'
                    }
                    this.model.grade = this.grade
                    this.model.pid = this.pid
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData(){
            this.model.grout_type = this.model.grout_type+""
            this.model.scene_type = this.model.scene_type+""
        },
    }
};
</script>